import {
  AccessGroup,
  AccessGroupCreateReq,
  AccessGroups,
  AccessGroupTenantReq,
  AccessGroupOrgUserReq,
  AccessGroupOrgUsersReq,
  AccessGroupOrgUsersDeleteReq,
} from '../types/accessGroup';
import type {Configuration} from '../configuration';
import type {AxiosInstance, AxiosPromise, RawAxiosRequestConfig} from 'axios';
import {BASE_PATH, BaseAPI, operationServerMap, RequestArgs} from '../base';
import globalAxios from 'axios';
import {
  DUMMY_BASE_URL,
  assertParamExists,
  createRequestFunction,
  serializeDataIfNeeded,
  setBearerAuthToObject,
  setSearchParams,
  toPathString,
} from '../common';
import {Tenants} from '../types/tenant';
import {OrgUsers} from '../types/orgUser';

/**
 * AccessGroupServiceApi - axios parameter creator
 * @export
 */
export const AccessGroupServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 租户添加
     * @summary 租户添加
     * @param {AccessGroupTenantReq} accessGroupTenantReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessGroupServiceAddTenant: async (
      accessGroupTenantReq: AccessGroupTenantReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'accessGroupTenantReq' is not null or undefined
      assertParamExists(
        'accessGroupServiceAddTenant',
        'accessGroupTenantReq',
        accessGroupTenantReq
      );
      const localVarPath = `/access_group/tenants`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        accessGroupTenantReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 权限组删除
     * @summary 权限组删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessGroupServiceDelete: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('accessGroupServiceDelete', 'id', id);
      const localVarPath = `/access_group/access_group/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 租户删除
     * @summary 租户删除
     * @param {AccessGroupTenantReq} accessGroupTenantReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessGroupServiceDeleteTenant: async (
      accessGroupTenantReq: AccessGroupTenantReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'accessGroupTenantReq' is not null or undefined
      assertParamExists(
        'accessGroupServiceDeleteTenant',
        'accessGroupTenantReq',
        accessGroupTenantReq
      );
      const localVarPath = `/access_group/tenants`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        accessGroupTenantReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 权限组详情
     * @summary 权限组详情
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessGroupServiceDetail: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('accessGroupServiceDetail', 'id', id);
      const localVarPath = `/access_group/access_group/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 权限组查询
     * @summary 权限组查询
     * @param {string} [orgId]
     * @param {Array<string>} [ids]
     * @param {string} [name] search access group name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessGroupServiceFind: async (
      orgId?: string,
      ids?: Array<string>,
      name?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/access_group/access_groups`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (orgId !== undefined) {
        localVarQueryParameter['orgId'] = orgId;
      }

      if (ids) {
        localVarQueryParameter['ids'] = ids;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 租户列表
     * @summary 租户列表
     * @param {string} [accessGroupId]
     * @param {string} [name] search tenant name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessGroupServiceFindTenant: async (
      accessGroupId?: string,
      name?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/access_group/tenants`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (accessGroupId !== undefined) {
        localVarQueryParameter['accessGroupId'] = accessGroupId;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 权限组保存
     * @summary 权限组保存
     * @param {AccessGroupCreateReq} accessGroupCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessGroupServiceSave: async (
      accessGroupCreateReq: AccessGroupCreateReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'accessGroupCreateReq' is not null or undefined
      assertParamExists('accessGroupServiceSave', 'accessGroupCreateReq', accessGroupCreateReq);
      const localVarPath = `/access_group/access_group`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        accessGroupCreateReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 权限组更新
     * @summary 权限组更新
     * @param {string} id
     * @param {AccessGroupCreateReq} accessGroupUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessGroupServiceUpdate: async (
      id: string,
      accessGroupUpdateReq: AccessGroupCreateReq,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('accessGroupServiceUpdate', 'id', id);
      // verify required parameter 'accessGroupUpdateReq' is not null or undefined
      assertParamExists('accessGroupServiceUpdate', 'accessGroupUpdateReq', accessGroupUpdateReq);

      const localVarPath = `/access_group/access_group/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );

      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        accessGroupUpdateReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 添加单个用户到权限组
     * @summary 添加单个用户到权限组
     * @param {AccessGroupOrgUserReq} accessGroupOrgUserReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessGroupServiceAddOrgUser: async (
      accessGroupOrgUserReq: AccessGroupOrgUserReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'accessGroupOrgUserReq' is not null or undefined
      assertParamExists(
        'accessGroupServiceAddOrgUser',
        'accessGroupOrgUserReq',
        accessGroupOrgUserReq
      );
      const localVarPath = `/access_group/org_user`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        accessGroupOrgUserReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },

    /**
     * 添加多个用户到权限组
     * @summary 添加多个用户到权限组
     * @param {AccessGroupOrgUsersReq} accessGroupOrgUsersReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessGroupServiceAddOrgUsers: async (
      accessGroupOrgUsersReq: AccessGroupOrgUsersReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'accessGroupOrgUsersReq' is not null or undefined
      assertParamExists(
        'accessGroupServiceAddOrgUsers',
        'accessGroupOrgUsersReq',
        accessGroupOrgUsersReq
      );
      const localVarPath = `/access_group/org_users`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        accessGroupOrgUsersReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },

    /**
     * 获取权限组中的用户列表
     * @summary 获取权限组中的用户列表
     * @param {string} accessGroupId
     * @param {string} [name]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessGroupServiceFindOrgUsers: async (
      accessGroupId: string,
      name?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'accessGroupId' is not null or undefined
      assertParamExists('accessGroupServiceFindOrgUsers', 'accessGroupId', accessGroupId);
      const localVarPath = `/access_group/org_users`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (accessGroupId !== undefined) {
        localVarQueryParameter['accessGroupId'] = accessGroupId;
      }
      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },

    /**
     * 从权限组删除用户
     * @summary 从权限组删除用户
     * @param {AccessGroupOrgUsersDeleteReq} accessGroupOrgUsersDeleteReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessGroupServiceDeleteOrgUsers: async (
      accessGroupOrgUsersDeleteReq: AccessGroupOrgUsersDeleteReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'accessGroupOrgUsersDeleteReq' is not null or undefined
      assertParamExists(
        'accessGroupServiceDeleteOrgUsers',
        'accessGroupOrgUsersDeleteReq',
        accessGroupOrgUsersDeleteReq
      );
      const localVarPath = `/access_group/org_users`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        accessGroupOrgUsersDeleteReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AccessGroupServiceApi - functional programming interface
 * @export
 */
export const AccessGroupServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AccessGroupServiceApiAxiosParamCreator(configuration);
  return {
    /**
     * 租户添加
     * @summary 租户添加
     * @param {AccessGroupTenantReq} accessGroupTenantReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accessGroupServiceAddTenant(
      accessGroupTenantReq: AccessGroupTenantReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accessGroupServiceAddTenant(
        accessGroupTenantReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AccessGroupServiceApi.accessGroupServiceAddTenant']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 权限组删除
     * @summary 权限组删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accessGroupServiceDelete(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accessGroupServiceDelete(
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AccessGroupServiceApi.accessGroupServiceDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 租户删除
     * @summary 租户删除
     * @param {AccessGroupTenantReq} accessGroupTenantReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accessGroupServiceDeleteTenant(
      accessGroupTenantReq: AccessGroupTenantReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accessGroupServiceDeleteTenant(
        accessGroupTenantReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AccessGroupServiceApi.accessGroupServiceDeleteTenant']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 权限组详情
     * @summary 权限组详情
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accessGroupServiceDetail(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessGroup>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accessGroupServiceDetail(
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AccessGroupServiceApi.accessGroupServiceDetail']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 权限组查询
     * @summary 权限组查询
     * @param {string} [orgId]
     * @param {Array<string>} [ids]
     * @param {string} [name] search access group name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accessGroupServiceFind(
      orgId?: string,
      ids?: Array<string>,
      name?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessGroups>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accessGroupServiceFind(
        orgId,
        ids,
        name,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AccessGroupServiceApi.accessGroupServiceFind']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 租户列表
     * @summary 租户列表
     * @param {string} [accessGroupId]
     * @param {string} [name] search tenant name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accessGroupServiceFindTenant(
      accessGroupId?: string,
      name?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tenants>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accessGroupServiceFindTenant(
        accessGroupId,
        name,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AccessGroupServiceApi.accessGroupServiceFindTenant']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 权限组保存
     * @summary 权限组保存
     * @param {AccessGroupCreateReq} accessGroupCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accessGroupServiceSave(
      accessGroupCreateReq: AccessGroupCreateReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessGroup>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accessGroupServiceSave(
        accessGroupCreateReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AccessGroupServiceApi.accessGroupServiceSave']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 权限组更新
     * @summary 权限组更新
     * @param {string} id
     * @param {AccessGroupCreateReq} accessGroupUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accessGroupServiceUpdate(
      id: string,
      accessGroupUpdateReq: AccessGroupCreateReq,
      options?: any
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessGroup>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accessGroupServiceUpdate(
        id,
        accessGroupUpdateReq,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * 添加单个用户到权限组
     * @summary 添加单个用户到权限组
     * @param {AccessGroupOrgUserReq} accessGroupOrgUserReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accessGroupServiceAddOrgUser(
      accessGroupOrgUserReq: AccessGroupOrgUserReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accessGroupServiceAddOrgUser(
        accessGroupOrgUserReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AccessGroupServiceApi.accessGroupServiceAddOrgUser']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },

    /**
     * 添加多个用户到权限组
     * @summary 添加多个用户到权限组
     * @param {AccessGroupOrgUsersReq} accessGroupOrgUsersReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accessGroupServiceAddOrgUsers(
      accessGroupOrgUsersReq: AccessGroupOrgUsersReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accessGroupServiceAddOrgUsers(
        accessGroupOrgUsersReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AccessGroupServiceApi.accessGroupServiceAddOrgUsers']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },

    /**
     * 获取权限组中的用户列表
     * @summary 获取权限组中的用户列表
     * @param {string} accessGroupId
     * @param {string} [name]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accessGroupServiceFindOrgUsers(
      accessGroupId: string,
      name?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgUsers>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accessGroupServiceFindOrgUsers(
        accessGroupId,
        name,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AccessGroupServiceApi.accessGroupServiceFindOrgUsers']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },

    /**
     * 从权限组删除用户
     * @summary 从权限组删除用户
     * @param {AccessGroupOrgUsersDeleteReq} accessGroupOrgUsersDeleteReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accessGroupServiceDeleteOrgUsers(
      accessGroupOrgUsersDeleteReq: AccessGroupOrgUsersDeleteReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accessGroupServiceDeleteOrgUsers(
        accessGroupOrgUsersDeleteReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AccessGroupServiceApi.accessGroupServiceDeleteOrgUsers']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AccessGroupServiceApi - factory interface
 * @export
 */
export const AccessGroupServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AccessGroupServiceApiFp(configuration);
  return {
    /**
     * 租户添加
     * @summary 租户添加
     * @param {AccessGroupTenantReq} accessGroupTenantReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessGroupServiceAddTenant(
      accessGroupTenantReq: AccessGroupTenantReq,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .accessGroupServiceAddTenant(accessGroupTenantReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 权限组删除
     * @summary 权限组删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessGroupServiceDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .accessGroupServiceDelete(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 租户删除
     * @summary 租户删除
     * @param {AccessGroupTenantReq} accessGroupTenantReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessGroupServiceDeleteTenant(
      accessGroupTenantReq: AccessGroupTenantReq,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .accessGroupServiceDeleteTenant(accessGroupTenantReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 权限组详情
     * @summary 权限组详情
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessGroupServiceDetail(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AccessGroup> {
      return localVarFp
        .accessGroupServiceDetail(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 权限组查询
     * @summary 权限组查询
     * @param {string} [orgId]
     * @param {Array<string>} [ids]
     * @param {string} [name] search access group name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessGroupServiceFind(
      orgId?: string,
      ids?: Array<string>,
      name?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AccessGroups> {
      return localVarFp
        .accessGroupServiceFind(orgId, ids, name, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 租户列表
     * @summary 租户列表
     * @param {string} [accessGroupId]
     * @param {string} [name] search tenant name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessGroupServiceFindTenant(
      accessGroupId?: string,
      name?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Tenants> {
      return localVarFp
        .accessGroupServiceFindTenant(accessGroupId, name, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 权限组保存
     * @summary 权限组保存
     * @param {AccessGroupCreateReq} accessGroupCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessGroupServiceSave(
      accessGroupCreateReq: AccessGroupCreateReq,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AccessGroup> {
      return localVarFp
        .accessGroupServiceSave(accessGroupCreateReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 权限组更新
     * @summary 权限组更新
     * @param {string} id
     * @param {AccessGroupCreateReq} accessGroupUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessGroupServiceUpdate(
      id: string,
      accessGroupUpdateReq: AccessGroupCreateReq,
      options?: any
    ): AxiosPromise<AccessGroup> {
      return localVarFp
        .accessGroupServiceUpdate(id, accessGroupUpdateReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 添加单个用户到权限组
     * @param {AccessGroupOrgUserReq} accessGroupOrgUserReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessGroupServiceApi
     */
    accessGroupServiceAddOrgUser(
      accessGroupOrgUserReq: AccessGroupOrgUserReq,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .accessGroupServiceAddOrgUser(accessGroupOrgUserReq, options)
        .then(request => request(axios, basePath));
    },

    /**
     * 添加多个用户到权限组
     * @param {AccessGroupOrgUsersReq} accessGroupOrgUsersReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessGroupServiceApi
     */
    accessGroupServiceAddOrgUsers(
      accessGroupOrgUsersReq: AccessGroupOrgUsersReq,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .accessGroupServiceAddOrgUsers(accessGroupOrgUsersReq, options)
        .then(request => request(axios, basePath));
    },

    /**
     * 获取权限组中的用户列表
     * @param {string} accessGroupId
     * @param {string} [name]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessGroupServiceApi
     */
    accessGroupServiceFindOrgUsers(
      accessGroupId: string,
      name?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<OrgUsers> {
      return localVarFp
        .accessGroupServiceFindOrgUsers(accessGroupId, name, options)
        .then(request => request(axios, basePath));
    },

    /**
     * 从权限组删除用户
     * @param {AccessGroupOrgUsersDeleteReq} accessGroupOrgUsersDeleteReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessGroupServiceApi
     */
    accessGroupServiceDeleteOrgUsers(
      accessGroupOrgUsersDeleteReq: AccessGroupOrgUsersDeleteReq,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .accessGroupServiceDeleteOrgUsers(accessGroupOrgUsersDeleteReq, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * AccessGroupServiceApi - object-oriented interface
 * @export
 * @class AccessGroupServiceApi
 * @extends {BaseAPI}
 */
export class AccessGroupServiceApi extends BaseAPI {
  /**
   * 租户添加
   * @summary 租户添加
   * @param {AccessGroupTenantReq} accessGroupTenantReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccessGroupServiceApi
   */
  public accessGroupServiceAddTenant(
    accessGroupTenantReq: AccessGroupTenantReq,
    options?: RawAxiosRequestConfig
  ) {
    return AccessGroupServiceApiFp(this.configuration)
      .accessGroupServiceAddTenant(accessGroupTenantReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 权限组删除
   * @summary 权限组删除
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccessGroupServiceApi
   */
  public accessGroupServiceDelete(id: string, options?: RawAxiosRequestConfig) {
    return AccessGroupServiceApiFp(this.configuration)
      .accessGroupServiceDelete(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 租户删除
   * @summary 租户删除
   * @param {AccessGroupTenantReq} accessGroupTenantReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccessGroupServiceApi
   */
  public accessGroupServiceDeleteTenant(
    accessGroupTenantReq: AccessGroupTenantReq,
    options?: RawAxiosRequestConfig
  ) {
    return AccessGroupServiceApiFp(this.configuration)
      .accessGroupServiceDeleteTenant(accessGroupTenantReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 权限组详情
   * @summary 权限组详情
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccessGroupServiceApi
   */
  public accessGroupServiceDetail(id: string, options?: RawAxiosRequestConfig) {
    return AccessGroupServiceApiFp(this.configuration)
      .accessGroupServiceDetail(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 权限组查询
   * @summary 权限组查询
   * @param {string} [orgId]
   * @param {Array<string>} [ids]
   * @param {string} [name] search access group name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccessGroupServiceApi
   */
  public accessGroupServiceFind(
    orgId?: string,
    ids?: Array<string>,
    name?: string,
    options?: RawAxiosRequestConfig
  ) {
    return AccessGroupServiceApiFp(this.configuration)
      .accessGroupServiceFind(orgId, ids, name, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 租户列表
   * @summary 租户列表
   * @param {string} [accessGroupId]
   * @param {string} [name] search tenant name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccessGroupServiceApi
   */
  public accessGroupServiceFindTenant(
    accessGroupId?: string,
    name?: string,
    options?: RawAxiosRequestConfig
  ) {
    return AccessGroupServiceApiFp(this.configuration)
      .accessGroupServiceFindTenant(accessGroupId, name, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 权限组保存
   * @summary 权限组保存
   * @param {AccessGroupCreateReq} accessGroupCreateReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccessGroupServiceApi
   */
  public accessGroupServiceSave(
    accessGroupCreateReq: AccessGroupCreateReq,
    options?: RawAxiosRequestConfig
  ) {
    return AccessGroupServiceApiFp(this.configuration)
      .accessGroupServiceSave(accessGroupCreateReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 权限组更新
   * @summary 权限组更新
   * @param {string} id
   * @param {AccessGroupCreateReq} accessGroupUpdateReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccessGroupServiceApi
   */
  public accessGroupServiceUpdate(
    id: string,
    accessGroupUpdateReq: AccessGroupCreateReq,
    options?: any
  ) {
    return AccessGroupServiceApiFp(this.configuration)
      .accessGroupServiceUpdate(id, accessGroupUpdateReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 添加单个用户到权限组
   * @param {AccessGroupOrgUserReq} accessGroupOrgUserReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccessGroupServiceApi
   */
  public accessGroupServiceAddOrgUser(
    accessGroupOrgUserReq: AccessGroupOrgUserReq,
    options?: RawAxiosRequestConfig
  ) {
    return AccessGroupServiceApiFp(this.configuration)
      .accessGroupServiceAddOrgUser(accessGroupOrgUserReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 添加多个用户到权限组
   * @param {AccessGroupOrgUsersReq} accessGroupOrgUsersReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccessGroupServiceApi
   */
  public accessGroupServiceAddOrgUsers(
    accessGroupOrgUsersReq: AccessGroupOrgUsersReq,
    options?: RawAxiosRequestConfig
  ) {
    return AccessGroupServiceApiFp(this.configuration)
      .accessGroupServiceAddOrgUsers(accessGroupOrgUsersReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 获取权限组中的用户列表
   * @param {string} accessGroupId
   * @param {string} [name]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccessGroupServiceApi
   */
  public accessGroupServiceFindOrgUsers(
    accessGroupId: string,
    name?: string,
    options?: RawAxiosRequestConfig
  ) {
    return AccessGroupServiceApiFp(this.configuration)
      .accessGroupServiceFindOrgUsers(accessGroupId, name, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 从权限组删除用户
   * @param {AccessGroupOrgUsersDeleteReq} accessGroupOrgUsersDeleteReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccessGroupServiceApi
   */
  public accessGroupServiceDeleteOrgUsers(
    accessGroupOrgUsersDeleteReq: AccessGroupOrgUsersDeleteReq,
    options?: RawAxiosRequestConfig
  ) {
    return AccessGroupServiceApiFp(this.configuration)
      .accessGroupServiceDeleteOrgUsers(accessGroupOrgUsersDeleteReq, options)
      .then(request => request(this.axios, this.basePath));
  }
}
